<template>
    <div>
        <IronBuiltValue v-if="type == 'iron'" :built="built" />
        <PutterBuiltValue v-if="type == 'putter'" :built="built" />
        <WedgeBuiltValue v-if="type == 'wedge'" :built="built" />
        <WoodBuiltValue v-if="type == 'wood'" :built="built" />
    </div>
</template>

<script>
import moment from 'moment';
import IronBuiltValue from './IronBuiltValue.vue';
import PutterBuiltValue from './PutterBuiltValue.vue';
import WedgeBuiltValue from './WedgeBuiltValue.vue';
import WoodBuiltValue from './WoodBuiltValue.vue';
export default {
    components:{
        IronBuiltValue,
        PutterBuiltValue,
        WedgeBuiltValue,
        WoodBuiltValue,
    },
    props: {
        built: {
            type: Object,
            required: true
        },
        type: {
            type: String,
            required: true
        }
    },
    filters:{
        formatDate (value) {
            if (!value) return '';
            return moment(value).format('DD/MM/YYYY, HH:mm:ss');
        }
    },
}
</script>

<style>

</style>